import { CollectiveProposal, CollectiveProposalStatus } from 'graphql/generated'
import { useMemo } from 'react'
import { useBreakpoint } from 'hooks/useBreakpoint'
import Typography from 'components/common/Typography'
import PanelStepper from 'components/common/PanelStepper'
import { noop } from 'lodash'

type TProposal = Pick<CollectiveProposal, 'status' | 'quorumNeeded'>

interface IProps {
  proposal: TProposal
}

function ProposalStatusBar({ proposal }: IProps) {
  const activeStep = useMemo(() => {
    switch (proposal.status) {
      case CollectiveProposalStatus.PENDING:
        return 0
      case CollectiveProposalStatus.ACTIVE:
      case CollectiveProposalStatus.DEFEATED:
        return 1
      case CollectiveProposalStatus.SUCCEEDED:
        return 2
      default:
        return 0
    }
  }, [proposal.status])

  const { isMobile } = useBreakpoint()

  if (proposal.status === CollectiveProposalStatus.EXECUTED) {
    return null
  }

  return (
    <div className="flex sm:flex-col gap-2">
      <PanelStepper
        steps={[{ label: `Propose` }, { label: `Vote` }, { label: `Execute` }]}
        setCurrentStep={noop}
        currentStep={1}
        vertical={isMobile}
      />

      <div className="max-w-lg mx-auto flex items-center">
        {activeStep === 0 && (
          <div className="mt-2 bg-gray-100 rounded-lg p-3">
            <Typography
              size="sm"
              fontWeight="light"
            >{`Voting will commence shortly`}</Typography>
          </div>
        )}

        {activeStep === 1 &&
          (proposal.status === CollectiveProposalStatus.DEFEATED ||
            proposal.status === CollectiveProposalStatus.ACTIVE) && (
            <div className="mt-3 bg-gray-100 rounded-lg p-3">
              <Typography size="sm" fontWeight="light">
                {proposal.status === CollectiveProposalStatus.DEFEATED &&
                  `This Proposal did not pass DAO voting, and therefore cannot be executed.`}
                {proposal.status === CollectiveProposalStatus.ACTIVE &&
                  `Members of the DAO will now vote. The proposal will need to
                be accepted by 50% + 1 of the votes, and have a minimum quorum
                participation of ${proposal.quorumNeeded} members.`}
              </Typography>
            </div>
          )}

        {activeStep === 2 && (
          <div className="mt-3 bg-gray-100 rounded-lg p-3">
            <Typography
              size="sm"
              fontWeight="light"
            >{`Successful Proposals need to be executed by the DAO's authorized signators`}</Typography>
          </div>
        )}
      </div>
    </div>
  )
}

export default ProposalStatusBar
